import { combineReducers } from "redux";

import UnauthorizedUserReducer from "./UnAuthorizedUser/reducer";

const rootReducers = combineReducers({
    UnauthorizedUserReducer,
})

export default rootReducers;